import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector:        'app-detailed-targeting-legend',
  template:        `
      <legend>
        <ng-content select=".app-detailed-targeting-legend__label"></ng-content>
        <ng-content select="app-info-icon"></ng-content>
        <ng-content select="app-close"></ng-content>
      </legend>`,
  styles:          [`
                      legend {
                        position:       relative;
                        display:        block;
                        width:          100%;
                        font-size:      1.2rem;
                        color:          #7f7f7f;
                        font-weight:    bold;
                        padding:        0;
                        margin:         0;
                        border:         none;
                      }
                    `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DetailedTargetingLegendComponent {
}
